import styled from "styled-components";
import { getImageURL } from "../../utilities";
const StyledWelcome = styled.section`
  & {
    padding-top: 5rem;
    background-image: url(${({ $imageContent }) =>
      getImageURL($imageContent?.bgDesktop)});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center bottom;
    text-align: center;
  }
  & br {
    display: none;
  }
  & .row {
    // margin: 0;
    padding: 0;
  }
  & .col {
    padding: 0;
  }
  & .title-box {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-flow: column nowrap;
    z-index: 1;
  }
  & .title-col {
    position: relative;
    margin-top: 8rem;
    overflow: visible;
  }
  & .title-col::before,
  & .title-col::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 0;
    background-image: url(${({ $imageContent }) =>
      getImageURL($imageContent?.curvedArrowsDesktop)});
      background-repeat: no-repeat;
    //   background-size: calc(40%) calc(100% - 1.5rem);
    // background-position: calc(45% - 265px) 1.5rem;
    background-position: calc(44% - 260px) 1.25rem;
      background-size: calc(40%) calc(100% - 1.5rem);
  }
  & .login {
    color: white;
    text-align: center;
    font-size: 20px;
    padding-top: 3rem;
  }
  & .title-col::after {
    transform: scaleX(-1);
  }

  & .title {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: calc(var(--welcome-h1-font-size) * var(--font-percentage));
    line-height: 125.5%;
    color: #ffffff;
  }
  & .subtitle {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: calc(var(--welcome-h3-font-size) * var(--font-percentage));
    line-height: 155.5%;
    color: #00beff;
    padding: 1rem 0 2rem 0;
  }
  & .subtext {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 200;
    font-size: calc(var(--welcome-p-font-size) * var(--font-percentage));
    line-height: 155.5%;
    color: #ffffff;
    margin-top: 5rem;
    padding-bottom: 10rem;
  }

  @media (max-width: 1400px) {
    & .title-col::before,
    & .title-col::after {
      background-position: calc(47% - 260px) 1.25rem;
      background-size: calc(43%) calc(100% - 1.5rem);
    }
  }
  @media (max-width: 1200px) {
    & .title-col::before,
    & .title-col::after {
      background-position: calc(50% - 250px) 1.25rem;
      background-size: calc(46%) calc(100% - 1.5rem);
    }
  }
  @media (max-width: 389px) {
    & .subtitle {
     font-size:21px!important;
    }
  }
  @media (max-width: 991px) {
    & .subtitle {
      padding: 0 0 2rem 0;
    }
    & .subtext {
      font-size: 20px;
    }
    & .title-col {
      position: relative;
      margin-top: 6rem;
    }
    & .title-col::before,
    & .title-col::after {
      overflow: visible;
      background-position: calc(50% - 205px) 1rem;
      background-size: calc(43%) calc(100% - 2rem);
    }
    & .subtext {
      margin-top: 3rem;
    }
  }
  @media (max-width: 767px) {
    & {
      padding-top: 5rem;
      background-image: url(${({ $imageContent }) =>
        getImageURL($imageContent?.bgMobile)});
    }
    & .title-col {
      margin-top: 9rem;
    }
    & .title {
      position: absolute;
      margin-top: -6.5rem;
    }
    & .subtitle {
      padding: 1rem 0 1rem 0;
    }
    & .subtext {
      margin: 2rem 0.5rem 0 0.5rem;
      font-size: calc(var(--welcome-p-font-size) * var(--font-percentage));
      padding-bottom: 7rem;

      font-weight: 200;
      font-size: 20px;
      text-align: justify;
    }
    & .title-col::before,
    & .title-col::after {
      background-image: url(${({ $imageContent }) =>
        getImageURL($imageContent?.curvedArrowsMobile)});
      background-position: calc(48% - 90px);
      background-size: calc(170px) calc(90%);
    }
    & br {
      display: unset;
    }
  }
  @media (max-width:575px){
    & .subtext {
      margin: 2rem 1.5rem 0 1.5rem;
     
    }
  }
  @media (max-width: 400px) {
    & .title {
      position: absolute;
      margin-top: -6rem;
    }
    & .title-col {
      margin-top: 8rem;
    }
    & .subtext {
      margin: 1rem 1rem 0 1rem;
      font-size: calc(var(--welcome-p-font-size) * var(--font-percentage));
    }
    & .title-col::before,
    & .title-col::after {
      background-image: url(${({ $imageContent }) =>
        getImageURL($imageContent?.curvedArrowsMobile)});
      background-position: calc(50% - 110px);
      background-size: calc(120px) calc(80%);
    }
  }
  @media (max-width: 350px) {
    & .title {
      position: absolute;
      margin-top: -6rem;
    }
    & .title-col {
      margin-top: 8rem;
    }
    & .subtext {
      margin: 1rem 0.5rem 0 0.5rem;
      font-size: calc(var(--welcome-p-font-size) * var(--font-percentage));
    }
    & .title-col::before,
    & .title-col::after {
      background-image: url(${({ $imageContent }) =>
        getImageURL($imageContent?.curvedArrowsMobile)});
      background-position: calc(50% - 90px);
      background-size: calc(120px) calc(80%);
    }
  }
`;
export default StyledWelcome;
